// Action enums
export enum ActionTypes {
  SET_COMMITTEES = "SET_COMMITTEES",
  FETCH_ALL_COMMITTEES = "FETCH_ALL_COMMITTEES",
}
